import type { GetServerSideProps } from 'next';

import AcquisitionLandingPageTemplate, {
  AcquisitionLandingPageTemplateProps,
  getTemplateServerSideProps,
} from '../../../components/page-templates/acquisition-landing-page-template';

const slug = 'media-landing-page-content';

const MediaLandingPage = ({
  activeOffers: serverSideOffers,
  pageContent: serverSidePageContent,
  placeholders: serverSidePlaceholders,
}: Omit<AcquisitionLandingPageTemplateProps, 'slug'>) => (
  <AcquisitionLandingPageTemplate
    activeOffers={serverSideOffers}
    pageContent={serverSidePageContent}
    placeholders={serverSidePlaceholders}
    slug={slug}
  />
);

export const getServerSideProps: GetServerSideProps = getTemplateServerSideProps({ slug });

export default MediaLandingPage;
